export default __webpack_public_path__ + "static/media/admin_marketing_active.94f519ac.svg";